import CollectionRootPage from './collectionRootPage';

export default CollectionRootPage;
